/* tslint:disable */
 
import { LocalizedValue } from './localized-value';
export class TimeZoneEntryDto {
  daylight_saving_time_dst?: boolean;
  id?: string;
  time_difference: string;
  time_zone: LocalizedValue;
  time_zone_id: string;
}
